import { MeetingCenterPage } from './MeetingCenter'

export function EvidenceHistoryPage() {
  return <MeetingCenterPage surface="evidence-history" />
}
